export type StaffRole = 'admin' | 'manager' | 'relationship_manager' | 'sales_executive';

const SEND_ROLES: StaffRole[] = ['admin', 'manager', 'relationship_manager'];
const REVIEW_ROLES: StaffRole[] = ['admin', 'manager'];

/** Normalises any casing from the API to a lowercase StaffRole, or null. */
const normaliseToStaffRole = (role: string | null): StaffRole | null => {
  if (!role) return null;
  const lower = role.toLowerCase();
  if (
    lower === 'admin' ||
    lower === 'manager' ||
    lower === 'relationship_manager' ||
    lower === 'sales_executive'
  ) {
    return lower as StaffRole;
  }
  return null;
};

/**
 * admin, manager, relationship_manager can send suggestions.
 * sales_executive cannot.
 */
export const canSendSuggestions = (role: string | null): boolean => {
  const r = normaliseToStaffRole(role);
  if (!r) return true; // unknown role → allow (safe fallback)
  return SEND_ROLES.includes(r);
};

/**
 * admin and manager can review suggestions.
 * relationship_manager and sales_executive cannot.
 */
export const canReviewSuggestions = (role: string | null): boolean => {
  const r = normaliseToStaffRole(role);
  if (!r) return true; // unknown role → allow (safe fallback)
  return REVIEW_ROLES.includes(r);
};

/**
 * The RM Suggestions tab is visible only when the user can send OR review.
 * sales_executive can do neither, so the tab is hidden for them.
 */
export const canViewSuggestionsTab = (role: string | null): boolean =>
  canSendSuggestions(role) || canReviewSuggestions(role);

export const isRelationshipManager = (role: string | null): boolean =>
  normaliseToStaffRole(role) === 'relationship_manager';

export const normalizeStaffRole = (role: string | null): StaffRole | null =>
  normaliseToStaffRole(role);
